import { z } from 'zod';
/** Blank passes as an empty string; non-empty values must be a UUID, returned lowercase (optional select fields). */
export const optionalUuidString = (invalidMessage) => z
    .string()
    .superRefine((value, context) => {
    if (!value.trim()) {
        return;
    }
    if (!z.uuid({ version: 'v7' }).safeParse(value).success) {
        context.addIssue({ code: 'custom', message: invalidMessage, path: [] });
    }
})
    .transform((value) => value.trim().toLowerCase());
//# sourceMappingURL=optional-uuid-string.js.map